import type { BackgroundValue } from '@elfsight/configurator-contracts';
import { isTransparentColor } from '@elfsight/widget-utils';

export function isTransparentBackground({ type, color }: BackgroundValue) {
  return type === 'color' && isTransparentColor(color);
}
